import { Routes } from '@angular/router';
import {
	createAuthRoutes,
	createVideoPopoutRoute,
	featureSettingsResolver,
	raceActiveGuard,
} from '@vbrick/vb-lxp-lib';
import { LivestreamViewComponent } from '@vbrick/vb-lxp-lib';
import { FullTimingComponent } from './full-timing/full-timing.component';
import { PreRaceComponent } from './pre-race/pre-race.component';
import { MapComponent } from './map/map';

export const routes: Routes = [
	createVideoPopoutRoute(),
	{
		path: '',
		component: LivestreamViewComponent,
		canActivate: [raceActiveGuard],
		resolve: {
			featureSettings: featureSettingsResolver,
		},
		data: {
			showLayoutControls: true,
			showTimingControl: true,
			showChatControl: true,
			showMapControl: false,
		},
	},
	...createAuthRoutes(),
	{
		path: 'full-timing',
		component: FullTimingComponent,
		data: {
			showLayoutControls: false,
			showTimingTowerControl: false,
			showChatControl: false,
			showMapControl: true,
		},
	},
	{
		path: 'pre-race',
		component: PreRaceComponent,
		data: {
			showLayoutControls: false,
			showTimingTowerControl: false,
			showChatControl: false,
			showMapControl: false,
		},
	},
	{
		path: 'map-popout',
		loadComponent: () => Promise.resolve(MapComponent),
		data: {
			showHeader: false,
			showFooter: false,
			showLayoutControls: false,
			showTimingControl: false,
			showTimingTowerControl: false,
			showChatControl: false,
			showMapControl: false,
			showRaceClassControl: false,
		},
	},
];
